module.exports = __webpack_public_path__ + "img/newcamera.979ca61f.png";